

import { atom , useRecoilValue, useSetRecoilState, useResetRecoilState} from "recoil";

const stockAtomList = atom({key:'profile_assign_to_user_atom', default:{user_info:[]}});


export  const SetPermissionProfileAssignToUserAtom = () => useSetRecoilState(stockAtomList);
export  const GetPermissionProfileAssignToUserAtom = () => useRecoilValue(stockAtomList);










